import { Logger } from "@lululemon/mwa-logger";

const log = new Logger({ owner: "snb", app: "cdp-app" });

export default log;
